import { useCallback } from 'react';

import { useSummarizationId } from 'hooks/useSummarizationId';
import { useWebsocketSubscription } from 'hooks/useWebsocketSubscription';
import { AIArtifactOptions } from 'models/AIArtifact';
import AIJob, { AIJobOptions, AIJobStatus } from 'models/AIJob';
import { AI_JOB_CHANNEL } from 'services/api/constants';

type AIJobChannelMessage = {
  id: string;
  status: AIJobStatus;
  type: string;
  error?: string;
  config?: {
    attachmentIds?: string[];
  };
  aiJobbableId: string;
  aiArtifact?: AIArtifactOptions;
};

type UseAIJobChannelOptions = {
  aiJobId?: string;
  onMessageReceived?: (job: AIJob) => void;
};

export default function useAIJobChannel({ aiJobId, onMessageReceived }: UseAIJobChannelOptions) {
  const handleReceived = useCallback(
    (data: AIJobChannelMessage) => {
      const job = new AIJob(data as AIJobOptions);

      onMessageReceived?.(job);
    },
    [onMessageReceived]
  );

  const summarizationId = useSummarizationId();

  const { isConnected } = useWebsocketSubscription<AIJobChannelMessage>({
    channel: AI_JOB_CHANNEL,
    params: { ai_job_id: aiJobId, ...(summarizationId ? { attachable_model: 'Summarization' } : {}) },
    onReceived: handleReceived,
    enabled: !!aiJobId,
  });

  return {
    isSubscribed: isConnected,
  };
}
